module.exports = __webpack_public_path__ + "img/mc175.5c7c6dde.jpg";